(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mg-promotions"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mg-promotions')) {
    class MgPromotions extends HTMLElement {
      connectedCallback() {
        this.designMode = this.hasAttribute('data-design-mode');
        this.countdowns = Array.from(this.querySelectorAll('[data-countdown]'));

        this.querySelectorAll('[data-copy]').forEach((btn) => {
          btn.addEventListener('click', () => this.copy(btn));
        });

        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const now = Date.now() / 1000;
        this.applySchedule(now);
        this.countdowns.forEach((el) => this.updateCountdown(el, now));
      }

      // Pages can be served from cache, so re-check start/end dates in the browser too.
      applySchedule(now) {
        if (this.designMode) return;
        this.querySelectorAll('.mgp__item[data-start], .mgp__item[data-end]').forEach((item) => {
          const start = Number(item.dataset.start || 0);
          const end = Number(item.dataset.end || 0);
          const live = (!start || now >= start) && (!end || now <= end);
          item.hidden = !live;
        });
      }

      updateCountdown(el, now) {
        const target = Number(el.dataset.countdown || 0);
        if (!target) return;

        const clock = el.querySelector('.mgp-countdown__clock');
        const ended = el.querySelector('.mgp-countdown__ended');
        let remaining = Math.max(0, Math.floor(target - now));

        if (remaining === 0) {
          clock.hidden = true;
          ended.hidden = false;
          if (el.hasAttribute('data-hide-when-finished') && !this.designMode) {
            el.closest('.mgp__item').hidden = true;
          }
          return;
        }

        const parts = {
          days: Math.floor(remaining / 86400),
          hours: Math.floor((remaining % 86400) / 3600),
          minutes: Math.floor((remaining % 3600) / 60),
          seconds: remaining % 60,
        };
        Object.entries(parts).forEach(([unit, value]) => {
          const node = el.querySelector(`[data-unit="${unit}"]`);
          if (node) node.textContent = String(value).padStart(2, '0');
        });
        clock.hidden = false;
        ended.hidden = true;
      }

      async copy(btn) {
        const original = btn.textContent;
        try {
          await navigator.clipboard.writeText(btn.dataset.copy);
          btn.textContent = btn.dataset.copiedLabel;
        } catch (e) {
          window.prompt('Copy this code:', btn.dataset.copy);
        }
        setTimeout(() => { btn.textContent = original; }, 2000);
      }
    }

    customElements.define('mg-promotions', MgPromotions);
  }

  } catch(e) { console.error(e); }
})();
})();
